// Этап 1 baltica_drivers: ETL-конфиг и привязка источников проекта (SDD 22 A4-A7)

const baseUrl = '/projects'

export const projectMlEndpoints = {
  exportConfig: (projectId: number): string => `${baseUrl}/${projectId}/ml-export-config`,
  resultConfig: (projectId: number): string => `${baseUrl}/${projectId}/ml-result-config`,
  sources: (projectId: number): string => `${baseUrl}/${projectId}/sources`,
  sourceTitles: (projectId: number): string => `${baseUrl}/${projectId}/sources/titles`,
  bindSource: (projectId: number, typeSource: string): string => `${baseUrl}/${projectId}/sources/${typeSource}/bind`,
  unbindSource: (projectId: number, typeSource: string): string =>
    `${baseUrl}/${projectId}/sources/${typeSource}/unbind`,
}
